import { ROUTES } from '@constants/constants';
import useLocale from '@hooks/useLocale';
import { RoutePage } from '@type-declarations/page';
import { TouristTrip, WithContext } from 'schema-dts';

export default function RouteSchema({ page }: { page: RoutePage }) {
  const locale = useLocale();

  const schema: WithContext<TouristTrip> = {
    '@type': 'TouristTrip',
    '@context': 'https://schema.org',
    name: page.title,
    description: page.introText,
    url: `${
      process.env.ENVIRONMENT_URL + ROUTES.LocationOverviewPage[locale]
    }/${page.slug}`,
    image: page.image?.url,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
